import React from 'react';

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));
const Home = React.lazy(() => import('./views/home/Home'));
const HomeMain = React.lazy(() => import('./views/home/HomeMain'));
const Cart = React.lazy(() => import('./views/cart/Cart'));
const Contact = React.lazy(() => import('./views/contact/Contact'));
const Product = React.lazy(() => import('./views/product/Product'));
const Success = React.lazy(() => import('./views/success/Success'));
const PrivateClass = React.lazy(() => import('./views/privateclass/PrivateClass'));
const Category = React.lazy(() => import('./views/category/Category'));
const Checkout = React.lazy(() => import('./views/checkout/Checkout'));
const Grade = React.lazy(() => import('./views/grade/Grade'));
const Courselist = React.lazy(() => import('./views/courselist/Courselist'));
const Servicedetails = React.lazy(() => import('./views/servicedetails/Servicedetails'));
const Subjectlist = React.lazy(() => import('./views/subjectlist/Subjectlist'));
const ProductDetails = React.lazy(() => import('./views/productdetails/ProductDetails'));
const Video = React.lazy(() => import('./views/productdetails/Video'));
const PaymentSuccess = React.lazy(() => import('./views/payment/PaymentSuccess'));
const TrialVideos = React.lazy(() => import('./views/TrialVideos/TrialVideos'));

const routes = [
  // { path: '/home', exact: true, name: 'Home', component: HomeMain },
  { path: '/home', name: 'Home', component: Home },
  { path: '/cart', name: 'Cart', component: Cart },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/product', name: 'Product', component: Product },
  { path: '/privateclass', name: 'PrivateClass', component: PrivateClass },
  { path: '/category', name: 'Category', component: Category },
  { path: '/checkout', name: 'Checkout', component: Checkout },
  { path: '/grade', name: 'Grade', component: Grade },
  { path: '/courselist', name: 'Courselist', component: Courselist },
  { path: '/servicedetails', name: 'Servicedetails', component: Servicedetails },
  { path: '/subjectlist', name: 'Subjectlist', component: Subjectlist },
  { path: '/productdetails', name: 'ProductDetails', component: ProductDetails },
  { path: '/video', name: 'Video', component: Video },
  { path: '/PaymentSuccess', name: 'PaymentSuccess', component: PaymentSuccess },
  { path: '/TrialVideos', name: 'TrialVideos', component: TrialVideos },
];

export default routes;
